// assets
import { FilePdfFilled, FileImageFilled  } from "@ant-design/icons";
import { BellFilledIcon } from "./icons";

// icons
const icons = {
  FilePdfFilled,
  FileImageFilled,
  BellFilledIcon
};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const admin = {
  id: "pages",
  title: "Admin Panel",
  type: "group",
 app: 'ipms',
  children: [
    {
      id: "pdf-manager",
      title: "Pdf Manager",
      type: "item",
      url: "/pdf-manager",
      icon: icons.FilePdfFilled,
      breadcrumbs: false,
    },

    {
      id: "image-manager",
      title: "Image Manager",
      type: "item",
      url: "/image-manager",
      icon: icons.FileImageFilled,
      breadcrumbs: false,
    },
    {
      id: "observed-pests",
      title: "User Observed Pests",
      type: "item",
      url: "/observed-pests",
      icon: icons.BellFilledIcon ,
      breadcrumbs: false,
    },
  ],
};

export default admin;
